const enStrings = {
    "Archivo ZIP en base64.": "Base64-encoded ZIP file.",
    "Comparar embeddings": "Compare embeddings",
    "Comparar rostros desde imagenes": "Compare faces from images",
    "Constancia generada": "Certificate generated",
    "Consulta RENAPO procesada": "RENAPO query processed",
    "Consultar CURP": "Query CURP",
    "Embedding generado": "Embedding generated",
    "Error interno": "Internal error",
    "Evaluar calidad de imagen": "Evaluate image quality",
    "Generar constancia NOM151": "Generate NOM151 certificate",
    "Generar embedding facial": "Generate facial embedding",
    "Lista Nominal": "Nominal List",
    "Modelos de reconocimiento facial": "Face Recognition Models",
    "Modelos de reconocimiento facial para calidad de imagen, embeddings y comparacion.":
        "Face recognition models for image quality, embeddings, and comparison.",
    "Modo de conformidad del modelo. Valores permitidos: Enrollment y Recognition. Si no se envia, el servicio usa Enrollment.":
        "Model conformance mode. Allowed values: Enrollment and Recognition. If omitted, the service uses Enrollment.",
    "Resultado de calidad de imagen": "Image quality result",
    "Resultado de comparacion": "Comparison result",
    "Servicio disponible": "Service available",
    "Servicio para consultar RENAPO por CURP.": "Service for querying RENAPO by CURP.",
    "Servicio para generar constancia NOM151 a partir de un archivo ZIP en base64.":
        "Service for generating a NOM151 certificate from a base64-encoded ZIP file.",
    "Servicio para validar INE en lista nominal.": "Service for validating INE against the nominal list.",
    "Servicios de calidad de imagen, embeddings y comparacion facial.":
        "Image quality, embeddings, and facial comparison services.",
    "Solicitud invalida": "Invalid request",
    "Token de Cognito invalido o ausente": "Invalid or missing Cognito token",
    "Validacion procesada": "Validation processed",
    "Validar INE": "Validate INE",
};

const translateValue = (value, language) => {
    if (language !== "en") return value;
    if (typeof value === "string") return enStrings[value] || value;
    if (Array.isArray(value)) return value.map((item) => translateValue(item, language));
    if (!value || typeof value !== "object") return value;

    return Object.entries(value).reduce((translated, [key, entry]) => {
        translated[key] = translateValue(entry, language);
        return translated;
    }, {});
};

export const translateOpenApiSpec = (spec, language) => translateValue(spec, language);
